import type { IGlobalState } from '@core/store'
import { getGlobalStoreHook } from '@core/store'
import type { EqualityChecker } from '@core/zustand'

/**
 *
 */
export function useGlobalStore<T>(
  selector: (state: IGlobalState) => T,
  equalityFn?: EqualityChecker<T>,
): T {
  return getGlobalStoreHook()(selector, equalityFn)
}
